import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { confirmationModal, setDirtyFormState } from 'redux/navigation'
import { moveNode } from 'redux/categories'
import { Segment, Table } from 'semantic-ui-react'
import CategoriesRow from './CategoriesRow'

const mapStateToProps = (state, ownProps) => {
  const { dirtyForm } = state.navigation
  return { dirtyForm }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      confirmationModal,
      setDirtyFormState,
      moveNode,
    },
    dispatch
  )
}

class CategoriesList extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
    this.state = {
      dragMarker: {},
    }
  }

  findCategory(dragId) {
    const { categories = [] } = this.props
    const item = categories.find((category) => dragId === category.id)
    return {
      item,
      index: categories.indexOf(item),
    }
  }

  moveCategory(sourceIndex, targetIndex) {
    const { categories = [] } = this.props
    const { moveNode } = this.props
    moveNode(
      categories[sourceIndex].id,
      categories[sourceIndex].parent_id,
      targetIndex
    )
  }

  handleSelect(id) {
    const {
      dirtyForm,
      push,
      confirmationModal,
      setDirtyFormState, //connect
    } = this.props
    if (dirtyForm) {
      confirmationModal({
        icon: config.icons.delete,
        negative: true,
        title: I18n.t('global.abortModal.title'),
        text: I18n.t('global.abortModal.text'),
        button: I18n.t('global.abortModal.button'),
        confirm: () => {
          push(config.nodes.category + id)
          setDirtyFormState(false)
        },
      })
    } else {
      push(config.nodes.category + id)
    }
  }

  getCategoryList() {
    const { dragMarker } = this.state
    const {
      categories,
      selectedId,
      dndName, //ownProps
    } = this.props //ownProps
    return categories.map((category, index) => (
      <CategoriesRow
        {...{
          index,
          category,
          dragMarker,
          dndName,
          setDragMarker: (dragMarker) => this.setState({ dragMarker }),
          findItem: (dragId) => this.findCategory(dragId),
          key: index,
          active: category.id === selectedId,
          dragId: category.id,
          handleSelect: this.handleSelect,
          moveItem: (sourceIndex, targetIndex) =>
            this.moveCategory(sourceIndex, targetIndex),
        }}
      />
    ))
  }

  render() {
    const dark = config.theme.dark
    return (
      <Segment
        attached
        className={classNames(['payload small', dark && 'inverted'])}>
        <Table
          sortable
          compact
          size="small"
          selectable
          singleLine
          basic="very"
          className="spaced">
          <Table.Body children={this.getCategoryList()} />
        </Table>
      </Segment>
    )
  }
}

CategoriesList = connect(mapStateToProps, mapDispatchToProps)(CategoriesList)
export default CategoriesList



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoriesList.jsx